import { CSSObject } from '@chakra-ui/react';
import background from '../../../assets/goldenrush/images/backgrounds/backgroundNotAllowLocation.png';
import backgroundAtRetina from '../../../assets/goldenrush/images/backgrounds/backgroundNotAllowLocationMB.png';

export const LocationNotAllowedContainer: CSSObject = {
  h: undefined,
  justifyContent: [null, null, 'center'],
  minH: '100vh',
  bgImage: `url(${background})`,
  bgRepeat: 'no-repeat',
  bgSize: ['100% 100%', '100%'],
  lineHeight: '4',

  '@media (-webkit-min-device-pixel-ratio: 2)': {
    bgImage: `url(${backgroundAtRetina})`,
  },
};

export const CenterWrapper: CSSObject = {
  bg: 'transparent',
  borderRadius: [null, null, 'xl'],
  color: 'white',
  flex: ['1', null, '0'],
  gap: '0',
  justifyContent: 'center',
  mt: ['0', null, '12'],
  mb: [null, null, '12'],
  minH: [null, null, '668px'],
  maxW: 'container.md',
  px: ['4', null, '28'],
  py: ['3', null, '8'],
  textShadow: '0 4px 10px rgba(0, 0, 0, .2)',
};

export const ContentHeadingText: CSSObject = {
  fontFamily: 'Angkor',
  fontSize: ['5xl', null, '5xl'],
  lineHeight: ['2.8rem', null, '3.6rem'],
  mt: ['1.5', null, '4'],
  mb: ['2.5', null, '4'],
  fontWeight: '400',
  textTransform: 'uppercase',
  color: 'gamma.500',
  w: [null, null, '1000px'],
};

export const ContentBodyText: CSSObject = {
  fontSize: ['md', 'lg'],
  lineHeight: 'tall',
  textAlign: 'center',
  filter: 'drop-shadow(0px 5px 5px rgba(0,0,0,.5))',

  b: {
    display: 'block',
    fontSize: 'md',
    lineHeight: 'base',
    mb: '4',
  },

  '.chakra-link': {
    fontSize: ['2xs', 'xs'],
    fontWeight: 'bold',
  },
};

export const ContactText: CSSObject = {
  '&&': {
    fontSize: ['sm', null, 'lg'],
  },
};

export const TextBodyCopy: CSSObject = {
  lineHeight: '5',
  fontSize: ['sm', null, 'lg'],
  mt: '4',
};

export const TextHeadingColor: CSSObject = {
  bgGradient: 'linear(to-b, alpha.500, gamma.500)',
  bgClip: 'text',
  textShadow: 'none',
  display: 'flex',
};

export const RegistrationContent: CSSObject = {
  fontSize: ['xs', null],
  w: [null, null, '591px'],
  '.chakra-link': {
    fontSize: ['xs', null],
    fontWeight: 'bold',
  },
};
